/*
 * FarmSteady — recipe kit footer visibility controller.
 *
 * Companion to snippets/fs-recipe-kit-footer.liquid. Same motion language
 * as the PDP sticky ATC (farmsteady-sticky-atc.js) but article-specific
 * logic:
 *
 *   SHOW  once the article header (.fs-article__header) has scrolled off
 *         the top edge — the reader is into the content.
 *   HIDE  while the inline kit card (.fs-kit-cta) is on screen — showing
 *         both at once is redundant — and come BACK once it scrolls off.
 *         (2026-08-18: the card moved above the recipe; the old permanent
 *         retire would have killed the bar right before the reader spent
 *         the longest stretch of the page cooking from the recipe card.)
 */

(function () {
  'use strict';

  function init() {
    const bar = document.querySelector('[data-fs-recipe-footer]');
    if (!bar || !('IntersectionObserver' in window)) return;

    const header = document.querySelector('.fs-article__header');
    if (!header) return;

    bar.hidden = false;
    let pastHeader = false;
    let cardOnScreen = false;

    function render() {
      bar.dataset.visible = pastHeader && !cardOnScreen ? 'true' : 'false';
    }

    const headerObserver = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        // Same "left via the top edge" rule as the PDP chip — prevents the
        // bar from appearing instantly on load when the header is below
        // the fold or the page opens mid-scroll.
        pastHeader = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
        render();
      },
      { threshold: 0 }
    );
    headerObserver.observe(header);

    const card = document.querySelector('.fs-kit-cta');
    if (card) {
      const cardObserver = new IntersectionObserver(
        (entries) => {
          cardOnScreen = entries[0].isIntersecting;
          render();
        },
        { threshold: 0.4 }
      );
      cardObserver.observe(card);
    }
  }

  if (['interactive', 'complete'].includes(document.readyState)) {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
